import React from 'react';
import { getMetaDescription } from '@/utils/getMetaDescription';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import Layout from '@/components/Layout';
import Collections from '@/containers/Collections';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { PAGE_TYPE_ID } from 'src/utils/constants';
import { getPageCanonicalUrl } from 'src/services/catalog';

const CollectionsSpecificToId = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={
        props?.advCustomSeoDetails?.title?.value
          ? props?.advCustomSeoDetails?.title?.value
          : `${storeInfo?.store_info?.name}${
              storeInfo?.address?.visibility === 1 && storeInfo?.address?.city
                ? `,${storeInfo?.address?.city}`
                : ''
            } - Order Online`
      }
      OGTitle={props?.advCustomSeoDetails?.og_title?.value || null}
      OGDescription={props?.advCustomSeoDetails?.og_description || null}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={
        props?.advCustomSeoDetails?.description
          ? props?.advCustomSeoDetails?.description
          : storeInfo && getMetaDescription(storeInfo)
      }
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      canonicalTagUrl={props?.canonicalUrlData?.item_group_details?.link}
      {...props}
    >
      <Collections {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  const userAgent = ctx?.req?.headers?.['user-agent'];
  if (checkForWrongDomain(ctx)) return {};

  let propData = {
    collections: [],
    canonicalUrlData: {},
  };
  const { collectionId } = ctx.params;

  const propType = await getSSRStoreData(ctx, {
    checkForSubscriptionExpiry: true,
    additionalDataToFetch: ['collections', 'categories', 'advancedSeo'],
    advancedSeoReqConfigs: {
      type: 'collection',
      typeId: collectionId,
    },
  });
  let canonicalUrlData = {};
    const storeId = propType?.ssrStore?.storeReducer?.store?.store_id;
    if (storeId) {
      canonicalUrlData = await getPageCanonicalUrl({
      storeId,
      type: PAGE_TYPE_ID.COLLECTION,
      typeId: collectionId,
    });
  }
  
    propData = { ...propData, ...propType, canonicalUrlData };

  return { props: { ...propData, userAgent } };
}

export default CollectionsSpecificToId;
